export default {
  button: {
    addDistributors: 'Ajouter des distributeurs',
    addMore: 'Ajouter plus',
    addMoreProduct: 'Ajouter plus de produits',
    addMoreProductForGiving: 'Ajouter plus de produits pour offrir',
    addMoreProductForOrder: 'Ajouter des produits à la commande',
    addMoreTime: 'Ajoutez plus de temps',
    addNewGroup: 'Ajouter un nouveau groupe',
    addProduct: 'Ajouter un produit',
    addSalesOrder: 'Ajouter une commande client',
    addStoreToGroup: 'Ajouter le magasin au groupe',
    addStores: 'Ajouter des magasins',
    addToStoreGroup: 'Ajouter au groupe de magasins',
    agree: 'Accepter',
    alreadyInOperation: 'Déjà en service',
    assign: 'Attribuer',
    btnCode: 'Voir le code QR d\'invitation à la boutique',
    cancel: 'Annuler',
    clear: 'Effacer',
    clearSelected: 'Effacer la sélection',
    close: 'Fermer',
    confirm: 'Confirmer',
    continueEditing: 'Continuer la modification',
    copyLink: 'Copier le lien',
    create: 'Créer',
    createANewReOrder: 'Créer une nouvelle commande',
    createNewDistributorMapping: 'Créer un nouveau mapping de distributeur',
    createNewStoreVisit: 'Créer une nouvelle visite de magasin',
    delete: 'Supprimer',
    detail: 'Détail',
    distributorDetial: 'Détails du distributeur',
    edit: 'Modifier',
    eventApplication: 'Application pour événement',
    eventExecution: 'Exécution de l\'événement',
    exchange: 'Échange',
    gotIt: 'J\'ai compris',
    ignore: 'Ignorer',
    invitationInfo: 'Informations sur l\'invitation',
    inviteStoresToParticipate: 'Inviter les magasins à participer',
    launch: 'Lancement',
    login: 'Se connecter',
    manage: 'Gérer',
    navigate: 'Naviguer',
    nextStep: 'Prochaine étape',
    previous: 'Précédent',
    reject: 'Rejeter',
    remove: 'Retirer',
    reset: 'Réinitialiser',
    review: 'Examen',
    save: 'Sauvegarder',
    search: 'Recherche',
    select: 'Sélectionner',
    selected: 'Sélectionné',
    sellOut: 'Ventes (sell-out)',
    stillCancel: 'Annulation en cours',
    storeDetial: 'Détails du magasin',
    storeInfo: 'Informations sur le magasin',
    storeTagDetermination: 'Détermination de l\'étiquette du magasin',
    submit: 'Soumettre',
    submitForReview: 'Soumettre pour examen',
    thinkAgain: 'Y réflechir',
    types: 'types',
    viewActivatedStores: 'Afficher les magasins activés',
    viewRecentReOrder: 'Afficher les dernières commandes',
    viewRecentVisitRecords: 'Consulter l\'historique des visites récentes',
    viewStoreMotivationStatus: 'Afficher l\'état de motivation du magasin',
    visitInfo: 'Informations sur la visite'
  },
  form: {
    achievementRate: 'Taux de réussite',
    actualTraffic: 'Trafic réel (Période de l\'événement)',
    addToSchedule: 'Ajouter au planning',
    address: 'Adresse',
    afterSalesQuantityPcs: 'Quantité après-vente (pièces)',
    afterSalesService: 'Service après-vente',
    afterTheEvent: 'Après l\'événement',
    assignedBaBd: 'BA/BD attribué',
    averageOfDisposableCustomerTraffic: 'Trafic moyen des clients à usage unique',
    averageOfOpenSystemCustomerTraffic: 'Trafic client moyen des systèmes ouverts',
    averageOfTraffic: 'Trafic moyen',
    averagePassengerFlow: 'Flux moyen de passagers',
    averageSalesPcsDay: 'Ventes moyennes (pièces/jour)',
    bannerFloorStandProductModelNotes: 'Modèle de produit pour bannière/support de sol(Remarques)',
    basicInfo: 'Informations de base.',
    beforeTheEvent: 'Avant l\'événement',
    brandBannerDisplayed: 'Bannière de marque en place',
    brandBannerProductModelNotes: 'Modèle de produit de bannière de marque(Remarques)',
    brandBuyers: 'Acheteurs de marques',
    brandDay: 'Brand Day',
    brandSupplierDistributor: 'Fournisseur de marque(distributeur)',
    business: 'Entreprise',
    businessStatus: 'Statut de l\'entreprise',
    businessType: 'Type d\'entreprise',
    chainOrNot: 'Chaîne ou pas',
    checkInPhoto: 'Photo check-in',
    chooseDate: 'Choisissez une date',
    cityNeighborhoodStreetOrBuilding: 'Ville, quartier, rue ou immeuble',
    competitorPrice: 'Prix du concurrent',
    consumablesRatio: 'Ratio de consommables (Ratio Pod/Mod / Ratio Resistances/Machine)',
    contactPosition: 'Poste occupé par le contact',
    corePromotedProductBrand: 'Marque de produit phare',
    country: 'Pays',
    createANewStoreMapping: 'Créer un nouveau mapping de magasins',
    currentProductListingStatus: 'Statut actuel de la liste des produits',
    customerReach: 'Zone de chalandise du',
    dayOfPromotion: 'Journée de promotion',
    daysInAdvance: 'Plusieurs jours à l\'avance',
    decisionMakerInfo: 'Informations sur le décideur.',
    decisionMakerName: 'Nom du décideur',
    decisionMakerRole: 'Rôle du décideur',
    directOrNot: 'Direct ou non',
    directSellIn: 'Vente (Sell-In) directe',
    displayMerchandising: 'Affichage et merchandising',
    displayPhoto: 'Afficher la photo',
    disposable: 'Jetable',
    disposableBrandDiversity: 'Diversité des marques de produits jetables',
    disposableCustomerTraffic: 'Trafic client jetable',
    disposableSales: 'Ventes de produits jetables',
    distributorID: 'ID du distributeur',
    distributorName: 'Nom du distributeur',
    distributorNamePostCodeAddressCityVisitBa: 'Nom du distributeur/Code postal/Adresse/Ville/Visiteé par un Ba',
    distributorTag: 'Étiquette du distributeur',
    distributorType: 'Type de distributeur',
    eXWEstimatedPrice: 'Prix EXW estimé ($)',
    editReason: 'Motif de la modification',
    email: 'E-mail',
    endOfSales: 'EFin des soldes',
    endTime: 'Heure de fin',
    estimatedPriceOfConsumablesEXW: 'Prix estimé des consommables EXW ($)',
    eventActualSales: 'Ventes réelles de l\'événement (pièces)',
    eventFeedback: 'Commentaires sur l\'événement',
    eventPhotos: 'Photos de l\'événement',
    eventSellInStoreTarget: 'Objectif de ventes en magasin',
    eventStoreContactName: 'Nom du contact du magasin pour les événements',
    eventTime: 'Heure de l\'événement',
    eventType: 'Type d\'événement',
    expectedTime: 'Délai prévu',
    facebookInstagramAvailable: 'Facebook / Instagram disponible',
    firistOrder: 'Première commande',
    firstTimeOrNot: 'Première fois ou pas',
    footTrafficInformation: 'Informations sur le trafic piétonnier.',
    image: 'Image',
    inv: 'Inv',
    invalid: 'Invalide',
    inventory: 'Inventaire',
    invitationsInfo: 'Informations sur les invitations',
    isItRecommendedForRoutineOperation: 'Est-ce recommandé pour une opération courante?',
    isThereAnInvitationForAnEvent: 'Y a-t-il une invitation pour un événement ?',
    kOSGroupInvitation: 'Invitation du groupe KOS',
    kOSGroupJoinScreenshot: 'Capture d\'écran de l\'adhésion au groupe KOS',
    keyDistributor: 'Distributeur clé',
    lastest: 'Dernières nouvelles',
    listed: 'Référencé',
    listing: 'Réferencé',
    listingOrNot: 'Référencement ou pas',
    listingProductSupplierDistributor: 'Référencement du fournisseur(distributeur)',
    listingStatus: 'Statut du referencement',
    lssueDeviceMode: 'Problème lié au mode de fonctionnement de l\'appareil',
    lssusDescription: 'Description du problème',
    mDWholesalePrice: 'Prix de gros MD ($)',
    marketFeedback: 'Feedback du marché',
    marketInformationCollection: 'Collecte d\'informations sur le marché',
    materialDelivery: 'Livraison de matériel',
    materialSampleDelivery: 'Livraison de matériel et d\'échantillons',
    materialSamplePhoto: 'Photo du matériel & echantillon',
    month: 'Mois',
    monthlyAverageSalesForKit: 'Ventes mensuelles moyennes de kits (pièces)',
    name: 'Nom',
    namePostCodeAddressCity: 'Nom/Code postal/Adresse/Ville',
    newBuyers: 'Nouveaux acheteurs',
    newBuyersReOrderStoreCount: 'Nombre de nouveaux acheteurs et de magasins ayant passé une nouvelle commande',
    newGroup: 'Nouveau groupe',
    notKeyDistributor: 'Distributeur non clé',
    notListing: 'Non référencé',
    notes: 'Notes',
    numberOfAffiliatedCoreStore: 'Nombre de magasins principaux affiliés',
    numberofChainStores: 'Nombre de magasins de la chaine',
    officialWebsiteAvailable: 'Site officiel disponible',
    openSystem: 'Système ouvert',
    openSystemCustomerTraffic: 'Trafic clients des systèmes ouverts',
    openSystemSales: 'Ventes de systèmes ouverts',
    orderGiftVolume: 'Volume des cadeaux pour la commande',
    orderModificationHistory: 'Historique des modifications de commande',
    orderSalesVolume: 'Volume des ventes',
    orders: 'commandes',
    other: 'Autre',
    otherCategory: 'Autre catégorie',
    otherCosts: 'Autres coûts (matériaux, etc.)',
    otherDistributor: 'Autre distributeur',
    outsidePicture: 'Image extérieure',
    overallSalesPerformance: 'Performance globale des ventes',
    pO: 'PO',
    pOOrder: 'Commande pré-commandée',
    paid: 'Payé',
    passengerFlowStatistics: 'Statistiques de flux de passagers (Période de l\'événement)',
    password: 'Mot de passe',
    paymentStatus: 'Statuts de paiement',
    paymentType: 'Type de paiement',
    pcs: 'pièces',
    percentageOfDisposable: 'Pourcentage de jetable',
    percentageOfOpenSystem: 'Pourcentage de systèmes ouverts',
    permanentlyClosed: 'Fermé définitivement',
    phone: 'Téléphone',
    phoneNumber: 'Numéro de téléphone',
    photo: 'Photo',
    planName: 'Nom du plan',
    plannedVisitDate: 'Date de visite prévue',
    pleaseSelect: 'Veuillez sélectionner',
    poPhoto: 'Photo de la preuve d\'achat',
    policy: 'Politique',
    popUp: 'Pop Up',
    popupDisplayPics: 'Photos d\'affichage pop-up',
    position: 'Position',
    posterDisplayed: 'Poster affiché',
    preEventWarmUpCooperation: 'Coopération de préparation à l\'événement',
    productCashCheque: 'Produit + Espèces/Chèque',
    productDailySales: 'Ventes quotidiennes du produit',
    productInfo: 'Informations sur le produit',
    productListingStatus: 'Etat référencement produit',
    productSalesInventory: 'Ventes et stocks de produits',
    promotionCapability: 'Capacité de promotion',
    promotionCapabillty: 'Capacité de promotion',
    promotionEffect: 'Effet promotionnel',
    quantityGivenAwayPcs: 'Quantité offerte(pièces)',
    quantitySoldPcs: 'Quantité vendue(pièces)',
    receipt: 'Reçu',
    recommendationsEventInvitations: 'Recommandations et invitations à des événements',
    recommendedForRoutineOperation: 'Recommandé pour une opération courante',
    reorderBuyers: 'Magasins ayant passé une nouvelle commande',
    retailPrice: 'Prix de détail',
    retailPriceMoney: 'Prix de détail ($)',
    retailerPurchasePrice: 'Prix d\'achat au détail',
    rollUpBannerOrFloorStandDisplay: 'Présentoir enroulable ou sur pied',
    ruleTipsOne: 'Veuillez sélectionner un magasin',
    salesBeforePromotion: 'Ventes avant promotion (pièces/jour)',
    salesPcs: 'Ventes(pièces)',
    salesPcsWeek: 'Ventes(unités/semaine)',
    salesPerformance: 'Performance des ventes',
    salesPerformancePcs: 'Performance des ventes (pièces)',
    salesReorderForecast: 'Prévisions des ventes et des réapprovisionnements',
    salesTargetForThisEventPcs: 'Objectif de vente pour cet événement (pièces)',
    sample: 'Échantillon',
    sampleConsumed: 'Échantillon consommé',
    sampleDelivery: 'Livraison d\'échantillons',
    sampleGiveawayPcs: 'Échantillons offerts (pièces)',
    samplePhoto: 'Photo de l\'echantillon',
    searchBrandOrProduct: 'Rechercher une marque ou un produit...',
    selectEndTime: 'Sélectionnez l\'heure de fin',
    selectProductsToUpdateListingStatus: 'Sélectionnez les produits pour mettre à jour le statut de réferencement produit',
    selectStartTime: 'Sélectionnez l\'heure de début',
    selectTimePeriod: 'Sélectionnez une période',
    sellInByMyselfThisTime: 'Vente par moi-même cette fois-ci',
    sellInFromAcmefog: 'Vente d\'Acmefog',
    sellInFromDistributor: 'Vente par le distributeur',
    sellInPhoto: 'Photo de vente',
    sellInQuantity: 'Quantité vendue (pièces)',
    sellOutOrders: 'Commandes ventes (sell-out)',
    sentOut: 'Envoyé',
    servicePhoto: 'Photo SAV',
    staffName: 'Nom du membre du personnel',
    startTime: 'Heure de début',
    storeCapacityVerification: 'vérification de la capacité du magasin',
    storeGroup: 'Groupe de magasins',
    storeID: 'ID du magasin',
    storeName: 'Nom du magasin',
    storeNamePostCodeAddressCityVisitBa: 'Nom du magasin/Code postal/Adresse/Ville/Visitez Ba',
    storePurchasePrice: 'Prix d\'achat magasin ($)',
    storeServiceRecords: 'Archive SAV du magasin',
    storeTag: 'Étiquette du magasin',
    storeType: 'Type de magasin',
    supportsPreEventInStoreDisplay: 'Permet la présentation en magasin avant l\'événement',
    tax: 'Taxe',
    taxExclusive: 'Taxes non comprises',
    taxInclusive: 'Taxes incluses',
    temporarilyClosed: 'Fermeture temporaire',
    testingStationDisplayed: 'Station de test en place',
    testingStationProductModelNotes: 'Modèle de produit de la station d\'essai(Remarques)',
    timePeriods: 'Périodes de temps',
    total: 'Total',
    totalDisposableSales: 'Ventes totales de produits jetables (pièces/semaine)',
    totalOpenSystemSales: 'Ventes totales de systèmes ouverts(pièces/semaine)',
    totalOpenSystemsSales: 'Ventes totales de systèmes ouverts (unités/semaine)',
    totalProductSales: 'Ventes totales de produits',
    totalSalesInStoreDuringEvent: 'Ventes totales en magasin pendant l\'événement (pièces)',
    totalSalesPcs: 'Ventes totales (pièces)',
    totalSellIn: 'Ventes total(Sell-In)',
    totalStoreTraffic: 'Trafic total du magasin',
    totalUsed: 'Total utilisé',
    uSD: 'USD',
    unpaid: 'Non payé',
    userName: 'Nom d\'utilisateur',
    visitDate: 'Date de visite',
    visitInfo: 'Informations sur la visite',
    warmUp: 'Préparations',
    warmUpType: 'Type de préparation',
    wayOfList: 'Méthode de référencement',
    weekdayFootTraffic: 'Fréquentation piétonne en semaine',
    weekdayPeakTraffic: 'Fréquentation piétonne le week-end',
    weekendFootTraffic: 'Fréquentation piétonne le week-end',
    weekendPeakTraffic: 'Pic de trafic du week-end',
    weeklySalesInventoryBrforeEventPcs: 'Ventes hebdomadaires et inventaire avant l\'événement (pièces)',
    whatsAppGroupAvailable: 'Groupe WhatsApp disponible',
    wholesalePurchasePrice: 'Prix d\'achat en gros',
    wholesaleRetailerPurchasePrice: 'Prix d\'achat en gros et au détail(USD)'
  },
  shared: {
    activity: 'Activité',
    addDistributorsToThePlan: 'Ajouter des distributeurs au plan',
    addNewStoreMapping: 'Ajouter un nouveau mapping de magasins',
    addNewStoreVisit: 'Ajouter une nouvelle visite de magasin',
    addNewVisitSchedulePlannedVisitDate: 'Ajouter un nouveau planning de visite, date de visite prévue：',
    addRetailStoresToThePlan: 'Ajouter des commerces de détail au plan',
    addToExistingPlan: 'Ajouter à un plan existant',
    addToVisitPlan: 'Ajouter au plan de visite',
    agreeToApplicationForKickOutOfOperation: 'Accepter la demande d\'exclusion de l\'opération',
    anEventToBeHeld: 'Un événement aura lieu',
    aplyToKickOutOfOperation: 'Demande d\'exclusion de l\'opération',
    applicable: 'En vigueur',
    applicant: 'Demandeur',
    applicationForKickOutOfOperation: 'Accepter la demande d\'exclusion de l\'opération',
    approvalTime: 'Délai d\'approbation',
    approved: 'Approuvé',
    approver: 'Approbateur',
    auditResult: 'Résultat de l\'audit',
    automaticallyAddCurrentItemAfterCreation: 'Ajouter automatiquement l\'élément actuel après sa création',
    bA: 'BA',
    balance: 'Solde',
    bindProduct: 'Produit lié',
    brandDayApplication: 'Application Journée de la Marque',
    buy: 'Acheter',
    by: 'par',
    byDay: 'Par jour',
    byTime: 'Par Date',
    byVisitBy: 'Visite effectuée par',
    cancelAllocationOfStores: 'Annulation de l\'attribution des magasins',
    cancelBrandDay: 'Annulation de la journée de la marque',
    cancelPopUpEvent: 'Annulation de l\'événement éphémère',
    cancelVisitSchedule: 'Annuler le planning de visite',
    changeDetails: 'Modifier les détails',
    closed: 'Fermé',
    collecting: 'En cours de collecte',
    completed: 'Complété',
    confirmRedemaption: 'Confirmer l\'échange',
    createNewVisitPlan: 'Créer un nouveau plan de visite',
    createVisitPlan: 'Élaborer un plan de visite',
    creditBreakdown: 'Détail du crédit',
    creditEarned: 'Crédit acquis',
    creditTransactionHistory: 'Historique des transactions de crédit',
    current: 'Actuelle',
    daily: 'Quotidien',
    dateOfInvitation: 'Date de l\'invitation',
    day: 'Jour',
    daysAgo: 'il y a 1 jour',
    deadline: 'Date limite',
    development: 'Développement',
    distributor: 'Distributeur',
    distributors: 'Distributeurs',
    distroInfo: 'Informations sur la distribution',
    dynamics: 'Dynamique',
    earnedPoints: '{totalIntegral} points gagnés',
    end: 'Fin',
    event: 'Événement',
    eventExecute: 'Exécution de l\'événement',
    eventInvitations: 'Invitations à l\'événement',
    eventInvite: 'Invitation à l\'événement',
    eventPolicy: 'Politique relative aux événements',
    expectTime: 'Prévoyez du temps',
    feedback: 'Feedback',
    filter: {
      accountManagement: 'Gestion de compte',
      activated: 'Activé',
      all: 'Tous',
      allType: 'Tout Type',
      average: 'Moyenne',
      brand: 'Marque',
      brandFilter: 'Filtrer la marque',
      confirm: 'Confirmer',
      containAll: 'Contient(Tout)',
      containAny: 'Contient(n\'importe lequel)',
      customize: 'Personnaliser',
      distanceEarliest: 'Magasin : plus ancien',
      distanceFarthest: 'Distance : la plus éloignée',
      distanceLatest: 'Magasin : plus récent',
      distanceNearest: 'Distance : la plus proche',
      effective: 'Efficace',
      endDate: 'Date de fin',
      filter: 'Filtre',
      good: 'Bien',
      goodTop: 'Bien : Marques haut de gamme et de milieu de gamme',
      high: 'Haut',
      inMonth: 'Dans un mois',
      inTwoWeeks: 'Dans deux semaines',
      inWeek: 'Dans une semaine',
      incentiveHistory: 'Historique des incentives',
      kA: 'KA',
      lessThanDays: 'Moins de 7 jours',
      low: 'Faible',
      mD: 'Master Distributeur',
      me: 'Moi',
      needTo: 'Necessaire',
      no: 'Non',
      noFilter: 'Pas de filtre',
      notActivated: 'Non activé',
      notContainAny: 'Ne contient(aucun)',
      notEqualTo: 'Pas égal à(Tous)',
      notNeedTo: 'Pas necessaire',
      notParticipated: 'N\'a pas participé',
      notSet: 'Non défini',
      operationBottonmost: 'Opération : la plus basse',
      operationTopmost: 'Opération : la plus haute',
      participated: 'A participé',
      poor: 'Pauvre',
      poorMainly: 'Mauvais : Principalement des grandes marques',
      potential: 'Potentiel',
      procMgr: 'Gestionnaire de processus',
      product: 'Produit',
      reset: 'Réinitialiser',
      rich: 'Riche',
      richTop: 'Riche : Marques haut de gamme, de milieu de gamme et de niche',
      russia: 'Russie',
      sDMultiItemDistro: 'SD(Distribution multi-articles)',
      sDSmokeDistro: 'SD(Distribution articles fumeur)',
      sVIPCore: 'SVIP Core',
      salesclerk: 'vendeur',
      selectDate: 'Sélectionner une date',
      selectEndDate: 'Sélectionner la date de fin',
      selectStartDate: 'Sélectionnez la date de début',
      shopkeeper: 'Commerçant',
      sort: 'Trier',
      startDate: 'Date de début',
      time: 'Heure',
      timeDays: '7 à 15 jours',
      timeFilter: 'Filtre par date',
      toBeVerified: 'À vérifier',
      type: 'Type',
      typeFilter: 'Type de filtre',
      unitedKingdom: 'Royaume-Uni',
      unitedStates: 'États-Unis',
      unknown: 'Inconnu',
      vIPCore: 'VIP Core',
      viewStore: 'Voir le magasin',
      yes: 'Oui'
    },
    from: 'à partir de',
    get: 'Obtenir',
    giveUpReason: 'Raison d\'abandonner',
    hideUpdate: 'Masquer « mise à jour »',
    insufficientPoints: 'Points insuffisants',
    inventoryPcs: 'Inventaire(pièces)',
    inviteFansToJoinTheCommunity: 'Invitez les fans à rejoindre la communauté',
    kickOut: 'Expulser',
    kickOutOfOperation: 'Exclusion de l\'opération',
    kilometer: 'km',
    launchPopUpEvent: 'Lancement de l\'evenement éphémère',
    listingProduct: 'Liste des produits',
    loading: 'Chargement...',
    locationName: 'Nom du lieu',
    mapping: 'Cartographie',
    markToIgnoreThisTransferAllocation: 'Selectionner pour ignorer ce transfert & attribution',
    materialSample: 'Materiel/Echantillon',
    materialSampleDeliveryDataMaintenance: 'maintenance des données de livraison de matériel et d\'échantillons',
    metre: 'm',
    modifiedProductQuantity: 'Quantité de produit modifiée',
    modifyBrandDayApplicationInfo: 'Modifier les informations de l\'application Journée de la marque',
    modifyPersonalInformation: 'Modifier les informations personnelles',
    modifyReOrder: 'Modifier la commande',
    modifyStoreTag: 'Modifier l\'étiquette du magasin',
    more: 'Plus',
    multiStopRoute: 'Itinéraire à arrêts multiples',
    myApproval: 'Mon approbation',
    nearbyStores: 'Magasins à proximité',
    need: 'Besoin',
    newDistributorMapping: 'Nouveau mapping distributeurs',
    newDistributorVisit: 'Visite du nouveau distributeur',
    newReOrder: 'Nouvelle commande',
    newVisitSellIn: 'Nouvelle visite et vente',
    nonEditable: 'Non modifiable',
    none: 'Aucun',
    notChangedYet: 'Pas encore modifié',
    notStarted: 'Pas encore commencé',
    offSite: 'Hors site',
    onSite: 'Sur site',
    operation: 'Opération',
    overdueFollowUp: 'Suivi en retard',
    pendingReview: 'En attente d\'examen',
    plannedVisitDate: 'Date de visite prévue',
    point: 'Indiquer',
    pointsRank: 'Classement par points',
    preEvent: 'Pré-événement',
    productBindingRecords: 'Enregistrements de liaisons de produit',
    productDetails: 'Détails du produit',
    proofOfDelivery: 'Preuve de livraison',
    psi: 'PSI',
    quanntityGivenAway: 'Quantité offerte',
    quanntitySold: 'Quantité vendue',
    reason: 'Raison',
    records: 'enregistrements',
    redeemIncentiveRewardsForEmployees: 'Utiliser les incentive pour les employés',
    redeemedCredit: 'Crédit racheté',
    rejectApplicationForKickingOutUpStore: 'Rejet de la demande d\'expulsion du magasin',
    rejected: 'Rejeté',
    relevantVisitPlans: 'Plans de visite pertinents',
    removedDistributor: 'Distributeur retiré',
    removedProducts: 'Produits retirés',
    reorder: 'Réassort',
    reorderPcs: 'Réassort(pièces)',
    report: 'Rapport',
    reportPopUpEventExecutionStatus: 'Rapport contextuel sur l\'état d\'exécution de l\'événement',
    reportingOnTheBrandDayExecution: 'Compte rendu de l\'exécution de la Journée de la marque',
    reviewStatus: 'État de l\'examen',
    rules: 'Règles',
    sN: 'Numéro de série',
    salesPcsWeek: 'Ventes(pièces/semaine)',
    schedule: 'Agenda',
    selectDistributor: 'Sélectionner un distributeur',
    selectFromExistingPlan: 'Choisissez parmis 4 plans existants',
    selectGiftToRedeem: 'Choisissez un cadeau à échanger',
    selectStore: 'Sélectionner un magasin',
    selectType: 'Sélectionner le type',
    sellOutDataMaintenance: 'Maintenance des données de vente',
    sellOutProduct: 'Produit épuisé',
    setAssignedBABDInTheManagementSystem: 'Définir l\'agent commercial/développeur attribué dans le système de gestion',
    setStoreLabels: 'Définir les etiquettes de magasins',
    setStoreTag: 'Définir l\'étiquette du magasin',
    setTheResponsiblePerson: 'Désigner la personne responsable',
    startingNow: 'À partir de maintenant',
    store: 'Magasin',
    storeActivity: 'Activité en magasin',
    storeAllocationTime: 'Date d\'allocation du magasin',
    storeID: 'ID du magasin',
    storeIncentive: 'Incentive magasin',
    storeIncentiveBindProduct: 'Incentive magasin: Liez le produit',
    storeIncentiveDeactivateEmployeeAccount: 'Incentive magasin: Désactivation du compte employé',
    storeIncentiveInviteEmployeeToActivate: 'Incentive magasin: Invitez un employé à activer',
    storeIncentiveUploadSalesProof: 'Incentive magasins: Téléchargez une preuve de vente',
    storeOperation: 'Opérations en magasin',
    storeParticipant: 'Participant en magasin',
    storeTagChange: 'Changement d\'étiquette du magasin',
    storeToDoItems: 'A faire dans le magasin',
    stores: 'Magasins',
    storesAreTransferredAndAllocatedTo: 'Les magasins sont transférés et affectés à ',
    storesLevel: 'Niveau des magasins',
    submissionTime: 'Date limite de soumission',
    success: 'succès',
    summary: 'Résumé',
    theFirstSaleOrInvitation: 'La première vente ou invitation',
    timeOfApplication: 'Date de la demande',
    title: {
      activatedStores: 'Magasins activés',
      anEventStoreToBeHeld: 'Un magasin événementiel sera tenu',
      basicInfo: 'Informations de base.',
      createANewGroup: 'Créer un nouveau groupe',
      createdSuccessfully: 'Créé avec succès',
      days: 'Jours',
      distributorInfo: 'Informations sur le distributeur',
      distributorMapping: 'Cartographie des distributeurs',
      distributorOperation: 'Opération distributeur',
      editGroupName: 'Modifier le nom du groupe',
      estimationOfResults: 'Estimation des résultats',
      eventHeld: 'Un événement éphémère a-t-il eu lieu ?',
      eventRecord: 'Enregistrement d\'événement',
      filterDepartment: 'Filtrer par département',
      filterPerson: 'Filtrer par personne',
      illDesc: 'Description de l\'illustration',
      incentive: 'Incentive',
      listState: 'Liste des États',
      manageMyGroups: 'Gérer mes groupes',
      mappingSucceed: 'Mapping réussi',
      marketInsight: 'Analyse du marché',
      mySchedule: 'Mon emploi du temps',
      orderDetail: 'Détails de la commande',
      orderUpdateRecord: 'Historique des modifications apportées aux commandes',
      others: 'Autres',
      overdueStoreFailureToFollowUp: 'Absence de suivi de la part du magasin concernant un retard de paiement',
      oversightMatters: 'Questions de contrôle',
      participationRecord: 'Dossier de participation',
      pleaseSelectYourWorkItems: 'Veuillez sélectionner vos éléments de travail',
      pointsRedemption: 'Échange de points',
      preparations: 'Préparations',
      productListed: 'Produits réferencés',
      prompt: 'Rapide',
      quickEntrance: 'Entrée rapide',
      reOrderOrNot: 'Réassort ou non',
      reOrderSellIn: 'Réapprovisionnement (Sell-In)',
      retailOperationSystem: 'Système d\'exploitation retail',
      ros: 'ROS',
      selectAPolicy: 'Sélectionnez une politique',
      selectGroup: 'Sélectionner un groupe',
      selectItemOfWork: 'Sélectionner l\'élément de travail',
      selectPlan: 'Choisir un plan',
      selectRegion: 'Sélectionner la région',
      selectYearAndMonth: 'Sélectionnez l\'année et le mois',
      state: 'État',
      storeAssignment: 'Affectation magasin',
      storeDevelopment: 'Développement des magasins',
      storeInfo: 'Informations sur le magasin',
      storeMapping: 'Mapping magasin',
      storeTag: 'Étiquette du magasin',
      storeVisit: 'Visite du magasin',
      storesToBeAllocated: 'Magasins à attribuer',
      theNumberOfProductsSold: 'Le nombre de produits vendus',
      timeSinceLastVisit: 'Temps écoulé depuis la dernière visite',
      transferAllocationRecords: 'Registres de transfert et d\'affectation',
      transferAndAllocate: 'Transférer et attribuer',
      visitByBa: 'Visité par le BA',
      visitOrNot: 'Visiter ou non',
      whichDay: 'Quel jour',
      minDays: 'Min. de jours',
      maxDays: 'Max. de jours'
    },
    titleEight: 'Aucun événement n\'est autorisé à durer plus de {days} jours.',
    titleEighteen: 'Confirmer la radiation de ce participant?',
    titleEleven: 'Etape 1 : Informations de bas sur l\'évenement',
    titleFifteen: 'Étape 3 : Liste des produits actuels et données de vente',
    titleFive: 'Le réapprovisionnement du magasin a été récemment mise à jour. Souhaitez-vous toujours ajouter une nouvelle commande?',
    titleFour: 'Vous avez récemment mis à jour les informations de visite de ce magasin. Continuer la modification?',
    titleFourteen: 'Veuillez vérifier s\'il y a des mises à jour. Les informations les plus récentes seront automatiquement ajoutées aux informations de base une fois la demande d\'inscription à l\'événement soumise avec succès.',
    titleNine: 'Le statut de l\'événement doit être soumis dans les délais. Un événement ne doit être renseigné qu\'une seule fois.',
    titleNineteen: 'Envoyez le contenu de la notification ci-dessus à la personne par SMS.',
    titleOne: 'Filtrer selon la condition suivante',
    titleSeven: 'Le résumé d\'activité suivant est généré automatiquement à partir des données que vous avez saisies.',
    titleSeventeen: 'Invitez vos fans à rejoindre la communauté et gagnez {totalIntegral} points',
    titleSix: 'La fiche de visite de ce magasin a été mise à jour récemment. Voulez-vous tout de même créer une nouvelle visite?',
    titleSixteen: 'Étape 4 : État de préparation de l\'événement actuel',
    titleTen: 'Le statut de l\'événement doit être soumis quotidiennement. Un résumé de l\'événement sera automatiquement généré à la fin de celui-ci.',
    titleThirteen: 'Les informations suivantes s\'afficheront automatiquement si elles ont déjà été saisies.',
    titleThirty: 'Une fois le transfert réussi et irréversible, assurez-vous que le magasin a déjà mis le produit en rayon.',
    titleThirtyOne: 'Le plan de visite a été créé avec succès et les magasins/distributeurs peuvent être ajoutés à l\'itinéraire de visite prévu.',
    titleThirtyThree: 'Faut-il mettre à jour les statuts des fiches produits cette fois-ci ?',
    titleThirtyTwo: 'Ajouter le {keyVal} à plus de plans de visite',
    titleThree: 'Vous avez récemment mis à jour le réapprovisionnement du magasin, continuez-vous à le modifier?',
    titleTwelve: 'Étape 2 Informations de base sur le {type}',
    titleTwenty: 'Invitez le personnel à se renseigner sur les conditions requises pour recevoir des primes.',
    titleTwentyEight: 'Le niveau du magasin n\'a pas été déterminé depuis la fin de l\'activité en magasin. Soumettre',
    titleTwentyFive: 'Exclure un magasin entraînera la résiliation de son autorisation et vous ne pourrez plus mettre à jour ses informations opérationnelles. Veuillez donc procéder avec prudence.',
    titleTwentyFour: 'Veuillez décrire le motif de l\'exclusion',
    titleTwentyNine: 'Transférez le magasin à une « équipe opérationnelle » et désignez-y un superviseur.',
    titleTwentyOne: 'Opération réussie. {currentIntegral} crédits a été déduit du compte de cet employé.',
    titleTwentySeven: '{backlogUserName} L\'événement {sourceName} commencera à {backlogTime}, allez voir',
    titleTwentySix: 'Des invitations à des événements seront bientôt lancées dans ce magasin. Consultez les informations sur les invitations.',
    titleTwentyThree: 'a demandé son exclusion de l\'opération',
    titleTwentyTwo: 'Êtes-vous sûr de vouloir supprimer ce produit?',
    titleTwo: 'Dernière visite de cette personne',
    titleThirtyFour: 'Ajouter un nombre minimum de jours, maximum de jours, ou les deux. Laisser vide si pas de limite.',
    to: 'à',
    toBeAllocated: 'À attribuer',
    today: 'aujourd\'hui',
    transferAllocation: 'Transferts et affectations',
    transferAndAssignStoresTo: 'Transférer et affecter les magasins à',
    underReview: 'En cours d\'examen',
    updateDistributorMapping: 'Mise à jour du mapping distributeur',
    updateDistributorVisit: 'Mise à jour visite distributeur',
    updatePopUpEvent: 'Mise à jour de l\'evenement éphémère',
    updateRecord: 'Mise à jour de l\'enregistrement',
    updateStoreInfoBy: 'mettre à jour les informations sur le magasin par',
    updateStoreMappingInformation: 'Mise à jour des informations de mapping des magasins',
    updateStoreVisitInformation: 'Mise à jour des informations sur les visites en magasin',
    updateVisitSellIn: 'Visite de mise à jour et vente',
    uploadSalesReceipt: 'Télécharger le reçu de vente',
    visit: 'Visite',
    visitPlan: 'Plan de visite',
    visitSellIn: 'Visite et vente',
    visitTime: 'Heure de visite',
    webSite: 'Site web',
    yesterday: 'hier'
  },
  tips: {
    accountOrPasswordIncorrect: 'Compte ou mot de passe incorrect',
    addressCopiedFailed: 'Échec de la copie de l\'adresse',
    addressCopiedSuccessfully: 'Adresse copiée avec succès',
    areYouSureToExit: 'Êtes-vous sûr de vouloir quitter?',
    browserDoesNotSupportCopyFunction: 'Le navigateur ne prend pas en charge la fonction de copie',
    checkInPhotoIsRequired: 'Une photo de check-in est requise',
    chooseOnePersonAtLeast: 'Choisissez au moins une personne',
    distributorPrice: 'Prix distributeur',
    eventCancelled: 'Événement annulé',
    filterByGroupName: 'Filtrer par nom de groupe',
    isRequired: 'est requis',
    locationNotFound: 'Lieu introuvable',
    loginSuccess: 'Connexion réussie',
    messageEight: 'Si ces informations ont déjà été soumises, l\'historique sera automatiquement renseigné. Veuillez les modifier directement en cas de changement',
    messageEleven: 'Y compris toutes les marques concurrentes jetables/ouvertes',
    messageFifteen: 'Confirmer la suppression de cette commande client?',
    messageFifty: 'Faut-il supprimer ce plan de visite ? Si un planning a déjà été créé, il sera annulé en conséquence.',
    messageFiftyOne: 'Souhaitez-vous retirer le {targetType} actuel du plan de visite et annuler le planning associé?',
    messageFiftyThree: 'Souhaitez-vous supprimer ce plan de visite? Si un planning a été créé, il sera annulé automatiquement',
    messageFiftyTwo: 'Crée automatiquement des plannings de visite pour les magasins/distributeurs ajoutés à ce plan',
    messageFive: 'L\'heure de fin doit être postérieure à l\'heure de début',
    messageForty: 'Mapping actuelle des magasins fonctionne avec succès, et davantage d\'informations sur les magasins peuvent être recueillies durant la visite',
    messageFortyEight: 'Supprimer ce groupe (Cette action supprime uniquement le groupe, et non les magasins qui le composent.)',
    messageFortyFive: 'L\'étiquette actuelle de la boutique est {customerTag}. Voulez-vous la modifier?',
    messageFortyFour: 'Après sa suppression, le magasin n\'apparaîtra plus sur la liste tant qu\'un ba n\'aura pas soumis une nouvelle demande',
    messageFortyNine: 'Confirmer le transfert du magasin et l\'attribuer à la personne responsable désignée ?',
    messageFortyOne: 'Modifier le statut du magasin en: {statusVal}, le magasin ne sera pas cartographié et ne sera pas visité, confirmer ou non?',
    messageFortySeven: 'Si votre demande est acceptée, l\'accès à la boutique vous sera accordé et transféré vers la zone « Extension ». L\'historique de vos opérations sera automatiquement archivé et ne pourra plus être modifié. Veuillez donc effectuer vos opérations avec précaution.',
    messageFortySix: 'Sera transféré au service « Développement » avec révocation des autorisations. Les enregistrements historiques des opérations seront archivés et ne pourront plus être modifiés.',
    messageFortyThree: 'Aucune vente ou référencement, ne peut être recommandée',
    messageFortyTwo: 'Vente par moi-même cette fois-ci requis',
    messageFour: 'Appuyez longuement pour enregistrer dans la bibliothèque/l\'album photo',
    messageFourteen: 'Effacer les matériaux sélectionnés et leurs quantités?',
    messageNine: 'Supprimer le produit effacera la quantité saisie. Voulez-vous le supprimer?',
    messageNineteen: 'Activités à réaliser : lorsqu\'un magasin est nouvellement attribué à des employés, si ce magasin dispose d\'une invitation à un événement, les employés doivent réaliser la présentation de l\'événement et mettre en ligne le compte-rendu de sa mise en œuvre dans les délais impartis.',
    messageOne: 'Créez indépendamment des groupes de magasins pour les catégoriser. Ces groupes ne sont visibles que par leur créateur.',
    messageSeven: 'L\'heure est incorrecte',
    messageSeventeen: 'En attente d\'examen : demandes à examiner.',
    messageSix: 'Veuillez remplir toutes les informations',
    messageSixteen: 'À attribuer : enregistrez une visite dans un magasin faisant partie du pool de magasins du groupe de développement. Si au moins un produit figure en rayon dans le compte-rendu de visite, le système générera automatiquement une fiche « magasin à attribuer », et le responsable des ventes au détail pourra transférer et attribuer le magasin à la personne désignée, qui se chargera du suivi et de la maintenance.',
    messageTen: 'Saisissez uniquement les données de ventes pré-événement le jour 1',
    messageThirteen: 'Une fois l\'événement annulé, vous ne pourrez plus remplir le rapport d\'événement. Confirmer l\'annulation?',
    messageThirty: 'Rejetez la demande de {createUserName} d\'expulser le magasin, que ce soit confirmé ou non',
    messageThirtyEight: 'En fonction du fonctionnement quotidien du magasin, définissez Etiquette du magasin sur',
    messageThirtyFive: 'Veuillez saisir des mots-clés pour rechercher des magasins',
    messageThirtyFour: 'Veuillez saisir le distributeur de {projectName}',
    messageThirtyNine: 'Selon l\'événement, Etiquette du magasin est réglé sur',
    messageThirtyOne: 'La date de fin ne peut pas être antérieure à la date de début',
    messageThirtySeven: 'Effacer les echantillons sélectionnés ainsi que les quantités saisies?',
    messageThirtySix: 'Veuillez saisir des mots-clés pour rechercher un distributeur',
    messageThirtyThree: 'Veuillez sélectionner la date de visite',
    messageThirtyTwo: 'La cartographie actuelle des distributeurs est concluante, et davantage d\'informations peuvent être recueillies lors d\'une visite',
    messageThree: 'Invitez le personnel à se porter candidat pour l\'attribution des récompenses.',
    messageTwelve: 'Votre demande d\'inscription à l\'événement a été soumise avec succès et l\'événement a été automatiquement ajouté à votre agenda quotidien',
    messageTwentyEight: 'Veuillez compléter vos informations',
    messageTwentyFive: 'Veuillez sélectionner une position',
    messageTwentyFour: 'Veuillez saisir votre nom',
    messageTwentyNine: 'Si la demande est acceptée, l\'accès au magasin sera transféré à l\'environnement de développement. L\'historique des opérations sera automatiquement archivé et ne pourra plus être modifié; veuillez donc effectuer vos opérations avec précaution',
    messageTwentyOne: 'Veuillez appuyer longuement sur le code QR pour enregistrer dans l\'album',
    messageTwentySeven: 'Activez l\'autorisation de l\'événement et envoyez une notification par SMS au téléphone portable de la personne',
    messageTwentySix: 'Veuillez saisir votre numéro de téléphone portable complet',
    messageTwentyThree: 'Pour garantir la bonne transmission du lien actif, veuillez confirmer que le numéro de téléphone saisi est correct',
    messageTwentyTwo: 'Impossible d\'obtenir l\'image du code QR',
    messageTwo: 'Supprimer le magasin du groupe (Le magasin lui-même ne sera pas supprimé.)',
    messgaeEighteen: 'Suivi en retard : selon les indicateurs d\'activité, une fréquence de suivi correspondante est définie pour les magasins phares et ceux à tester ; si le délai de suivi dépasse l\'intervalle prédéfini, une alerte précoce est déclenchée.',
    messgaeTwenty: 'Participez à l\'offre en scannant le code QR ou en cliquant sur le lien',
    networkError: 'Erreur réseau',
    noAvailablePolicies: 'Aucune politique disponible',
    noData: 'Aucune donnée',
    noMore: 'Pas plus',
    noMoreData: 'Plus aucune donnée',
    noMoreProducts: 'Plus de produits',
    noMoreStores: 'Plus aucun magasin',
    noMoreThan: 'Pas plus de 5',
    noPermissionYet: 'Aucune autorisation pour le moment',
    nothingMore: 'Il n\'y a rien de plus !',
    noticeCopiedFailed: 'L\'avis copié a échoué',
    noticeCopiedSuccessfully: 'Avis copié avec succès',
    passwordIsRequired: 'Un mot de passe est requis',
    pending: 'En attente',
    planningTheRoute: 'Planifier l\'itinéraire',
    pleaseChooseWhichDayToSell: 'Veuillez choisir le jour de votre vente',
    pleaseEnterAnInteger: 'Veuillez saisir un entier',
    pleaseEnterGroupName: 'Veuillez saisir le nom du groupe',
    pleaseFillInTheSales: 'Veuillez remplir les informations de ventes',
    pleaseInputTheSales: 'Veuillez saisir les ventes',
    pleaseSelectAGroup: 'Veuillez sélectionner un groupe',
    pleaseSelectProduct: 'Veuillez sélectionner un produit',
    pleaseSelectThePlan: 'Veuillez selectionner le plan',
    productIsRequired: 'Produit requis',
    reasonIsRequired: 'Une raison est requise',
    required: 'requis',
    sellInFromAcmefogInIsRequired: 'La vente par Acmefog est requise',
    stayTuned: 'Restez à l\'écoute',
    storeTagIsRequired: 'L\'étiquette StoreTag est requise.',
    successSave: 'Enregistré avec succès',
    uploadFailed: 'Échec du chargement',
    usernameIsRequired: 'Un nom d\'utilisateur est requis'
  }
}
